var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99289 6.14844C7.08005 6.14844 6.33203 6.89646 6.33203 7.80929C6.33203 8.72213 7.08005 9.47015 7.99289 9.47015C8.90572 9.47015 9.65374 8.72213 9.65374 7.80929C9.65374 6.89646 8.90572 6.14844 7.99289 6.14844Z",
    fill: "#242424"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.65304 6.14844C0.740206 6.14844 -0.0078125 6.89646 -0.0078125 7.80929C-0.0078125 8.72213 0.740206 9.47015 1.65304 9.47015C2.56588 9.47015 3.3139 8.72213 3.3139 7.80929C3.3139 6.89646 2.56588 6.14844 1.65304 6.14844Z",
    fill: "#242424"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3327 6.14844C13.4199 6.14844 12.6719 6.89646 12.6719 7.80929C12.6719 8.72213 13.4199 9.47015 14.3327 9.47015C15.2456 9.47015 15.9936 8.72213 15.9936 7.80929C15.9936 6.89646 15.2456 6.14844 14.3327 6.14844Z",
    fill: "#242424"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.4813ba2e69ea9fb10110b41aaf20f0d6.svg";
export { ForwardRef as ReactComponent };